import React from 'react';

function MenstruationSupport() {
  return (
    <div className="container mt-5">

      {/* App Description */}
      <section className="mt-4">
        <h2>Menstruation Tracker – Support Page</h2>
        <p>
          Welcome to the Menstruation Tracker Support Page. Our goal is to help you 
          track your menstrual cycle easily, privately, and accurately. If you need help 
          using the app, this guide will walk you through everything.
        </p>
      </section>

      {/* About the App */}
      <section className="mt-4">
        <h1>About the App</h1>
        <p>
          Menstruation Tracker lets you record your period dates and notes, helping you 
          understand your menstrual patterns over time. All your data is stored only on 
          your device, ensuring complete privacy.
        </p>
      </section>

      {/* How to Use */}
      <section className="mt-4">
        <h1>How to Use the App</h1>

        <h3>1. Add Period Date & Notes</h3>
        <ul>
          <li>Tap the “+” button on the home screen.</li>
          <li>Select your period start date.</li>
          <li>(Optional) Add notes like symptoms or mood.</li>
          <li>Tap <strong>Save</strong>.</li>
        </ul>

        <h3>2. Edit Period Date or Notes</h3>
        <ul>
          <li>Open the <strong>History</strong> screen.</li>
          <li>Select the entry you want to edit.</li>
          <li>Tap <strong>Edit</strong>.</li>
          <li>Update the date or notes.</li>
          <li>Tap <strong>Save</strong>.</li>
        </ul>

        <h3>3. Delete a Period Entry</h3>
        <ul>
          <li>Open the <strong>History</strong> screen.</li>
          <li>Select the entry you want to delete.</li>
          <li>Tap <strong>Delete</strong>.</li>
          <li>Confirm deletion.</li>
          <li><strong>Note:</strong> Deleted entries cannot be recovered.</li>
        </ul>

        <h3>4. Monthly Period History</h3>
        <ul>
          <li>Go to <strong>Period History</strong>.</li>
          <li>Scroll through months to view all your past period records.</li>
          <li>Helps you track cycle patterns and irregularities.</li>
        </ul>

        <h3>5. View Period Report</h3>
        <ul>
          <li>Open the <strong>Period Report</strong> screen.</li>
          <li>Choose a start date and end date.</li>
          <li>View a detailed summary of your periods within that date range.</li>
        </ul>
      </section>

      {/* Privacy and Security */}
      <section className="mt-4">
        <h1>Privacy & Data Security</h1>
        <ul>
          <li>All data is stored locally on your device.</li>
          <li>We do not collect, store, or upload any information.</li>
          <li>No account signup required.</li>
          <li>The app works entirely offline.</li>
          <li>If you delete the app, all your data will be permanently removed.</li>
        </ul>
      </section>

      {/* FAQ */}
      <section className="mt-4">
        <h1>Frequently Asked Questions (FAQ)</h1>

        <h3>1. Is my data safe?</h3>
        <p>Yes. All data stays on your device. We do not collect or access anything.</p>

        <h3>2. Can deleted entries be restored?</h3>
        <p>No. Once deleted, entries cannot be recovered.</p>

        <h3>3. Does the app predict future periods?</h3>
        <p>No. This version focuses on tracking only. Prediction features may come in future updates.</p>

        <h3>4. Does the app require internet?</h3>
        <p>No. The app works fully offline.</p>
      </section>

      {/* Contact Section */}
      <section className="mt-4">
        <h2>Contact Support</h2>
        <p>
          If you have any questions, issues, or feedback, feel free to reach out at:  
          <br />
          <strong>info@dakshyaai.com</strong>
        </p>
        <p>We’re always here to help.</p>
      </section>

    </div>
  );
}

export default MenstruationSupport;
